



















































import Vue from 'vue';
import SelectWithCustom from "./SelectWithCustom.vue";
import truncateStringMiddle from '../helpers/truncateStringMiddle';

const $ = window.jQuery;

export default Vue.extend({
	data: function () {
		return {
			i18nStrings: window.GPPA_ADMIN.strings,
		};
	},
	components: {
		'gppa-select-with-custom': SelectWithCustom,
	},
	props: [
		'flattenedProperties',
		'objectTypeInstance',
		'populate',
		'groupedProperties',
		'ungroupedProperties',
		'propertiesLoaded',
		'templateRows',
		'value',
	],
	watch: {},
	computed: {
		templatePropertiesGrouped: function () {
			const groupedProperties: { [groupId: string]: any[] } = {...this.groupedProperties};

			for ( const [groupId, properties] of Object.entries(groupedProperties) ) {
				groupedProperties[groupId] = properties.filter(property => property?.['supports_templates'] !== false);

				if (groupedProperties[groupId].length === 0) {
					delete groupedProperties[groupId];
				}
			}

			return groupedProperties;
		},
		templatePropertiesUngrouped: function () {
			return this.ungroupedProperties?.filter((property: any) => property?.['supports_templates'] !== false);
		},
	},
	methods: {
		truncateStringMiddle,
		updateTemplate: function(templateRowId: string, value: string) {
			Vue.set(this.value, templateRowId, value);
			this.$emit('input', this.value);
		}
	}
});
